import { handleActions } from 'redux-actions';
import immutable from 'object-path-immutable';
import * as actions from './actions';

const defaultState = {
  show_change_browser_modal: false
};

const appReducer = handleActions(
  new Map([
    [actions.showChangeBrowserModal,
      (state, action) => immutable.set(state, 'show_change_browser_modal', true)],
    [actions.hideChangeBrowserModal,
      (state, action) => immutable.set(state, 'show_change_browser_modal', false)],
  ]),
  defaultState
);

export default appReducer;


// WEBPACK FOOTER //
// ./src/app/modules/app/store/check-browser/reducer.ts